import KendoSparklineMixin from './KendoSparklineMixin'

export default {
    name: 'kendo-sparkline',
    mixins: [ KendoSparklineMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/index.js